export enum TemporaryStateKey {
  EVENT,
  WEAVE_QUALITY,
  DEVICE_TEMPLATE,
  PRODUCTION_SCHEDULE,
  REJECT_REASON
}
